/*
 * A LINK TO A CHARACTER'S PAGE (2026-11-02: "allow link directly to a
 * character's info page. like if i click a character in the highscores, i
 * should be able to copy the current page and someone else can view it the
 * same"). While a character's page is open the address ends
 * #character=<name>, and an address that ends so opens that page as it
 * comes up, logged in or not.
 *
 * The world is the site: Sydney's characters are at midgarth.quest and
 * Toronto's at yyz.midgarth.quest (worlds.ts), and each site's /character
 * reads only its own. So the link names no world of its own, and a page
 * that arrives by one stays where it is rather than going on to the world
 * picked last time, as a link to #changes does.
 */

const PREFIX = "#character=";

/** The end of the address that opens name's page. */
export function characterHash(name: string): string {
  return PREFIX + encodeURIComponent(name);
}

/** The name an address's hash opens the page of, or null for one that opens none. */
export function characterInHash(hash: string): string | null {
  if (!hash.startsWith(PREFIX)) return null;
  let name: string;
  try {
    name = decodeURIComponent(hash.slice(PREFIX.length));
  } catch {
    return null; // a broken %-escape, from a link cut short
  }
  name = name.trim();
  return name ? name : null;
}
